module.exports = __webpack_public_path__ + "static/media/lamina19actividad.846add79.png";